import {useContext} from 'react';
import {AppContext} from 'app/contexts';

const useAppContext = () => useContext(AppContext);

export default useAppContext;
